export enum AppPathsEnum {
  ROOT = "/",
  COMPONENTS_LIBRARY = "components-library",
}

export enum AppRoutesEnum {
  ROOT = "/",
  COMPONENTS_LIBRARY = "/components-library",

  // TODO: will be removed in the future since each page route have their own routes enum
  APPOINTMENTS = "/appointments",
  KEM = "/kem",
  NAVIHEALTH = "/navi-health",
  NOTIFICATIONS = "/notifications",
  SUBSCRIPTIONS = "/subscriptions",
  SYMPTOM_TRACKER = "/symptom-tracker",
  MENU = "/menu",
}
